var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-text-theme",attrs:{"type":"button"},on:{"click":function($event){_vm.copyUrl()}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'share-square']}}),_vm._v(" Share\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }